import ShareDialog from './ShareDialog';

export default ShareDialog;
